import type { Texts } from '../useTexts'

export const createValidateSubject = (
  texts: Texts,
  subject: string | undefined,
  required: boolean,
) => {
  const maxLength = 50

  const subjectCustomRequiredError = {
    id: 'subjectCustomRequiredError',
    field: 'subjectCustom',
    message: texts.requiredField,
    priority: 10,
  }

  const subjectCustomMaxLengthError = {
    id: 'subjectCustomMaxLengthError',
    field: 'subjectCustom',
    message: texts.subjectTooLong(maxLength),
    priority: 9,
  }

  const requiredError = required && subject?.trim().length === 0
  const maxLengthError = required && subject && subject.length > maxLength

  return {
    [subjectCustomRequiredError.id]: requiredError ? subjectCustomRequiredError : undefined,
    [subjectCustomMaxLengthError.id]: maxLengthError ? subjectCustomMaxLengthError : undefined,
  }
}
